<template>
  <navbar>
    <button class="navbar-toggler mobile-sidebar-toggler hidden-lg-up" type="button" @click="mobileSidebarToggle">
      &#9776;
    </button>
    <a class="navbar-brand" href="#"></a>
    <ul class="nav navbar-nav hidden-md-down">
      <li class="nav-item">
        <a class="nav-link navbar-toggler sidebar-toggler" href="#" @click="sidebarToggle">&#9776;</a>
      </li>
      <!--<ol class="breadcrumb">-->
        <li class="breadcrumb-item"><span class="active"></span>
          <!--<router-link :to="item.path" v-else>{{ showName(item) }}</router-link>-->
          <router-link :to="'/'">{{web_texts.header.select_system}}</router-link>
          <span> | {{system.name}}</span>
        </li>
      <!--</ol>-->
    </ul>

<!--    <ul class="navbar-nav">-->
<!--      <dropdown size="nav" class="nav-item">-->
<!--        <span slot="button">-->
<!--          <span class="">IDIOMA</span>-->
<!--        </span>-->
<!--        <div slot="dropdown-menu" class="dropdown-menu dropdown-menu-center">-->
<!--          <a class="dropdown-item" @click="changeLang('cat')">CAT &emsp;&emsp; <img :src="'static/img/catalonia.png'" class="img-avatar" height="42" width="42" ></a>-->
<!--          <a class="dropdown-item" @click="changeLang('es')">ESP &emsp;&emsp; <img :src="'static/img/spain.png'" class="img-avatar" height="42" width="42"></a>-->
<!--        </div>-->
<!--      </dropdown>-->
<!--    </ul>-->


    <ul class="nav navbar-nav ml-auto">
       <dropdown size="nav" class="nav-item">
        <span slot="button">
          <span class="">IDIOMA</span>
        </span>
        <div slot="dropdown-menu" class="dropdown-menu dropdown-menu-center">
          <a class="dropdown-item" @click="changeLang('cat')"><img :src="'static/img/catalonia.png'" height="21" width="21">&emsp; CATALÀ</a>
          <a class="dropdown-item" @click="changeLang('es')"><img :src="'static/img/spain.png'" height="21" width="21">&emsp; ESPAÑOL</a>
        </div>
      </dropdown>
      &emsp;
      <dropdown size="nav" class="nav-item">
        <span slot="button">
          <img src="static/img/avatars/default_avatar.png" class="img-avatar" alt="admin@bootstrapmaster.com">
          <span class="hidden-md-down">{{user.name}}</span>
        </span>
        <div slot="dropdown-menu" class="dropdown-menu dropdown-menu-right">
          <div class="dropdown-header text-center"><strong>Settings</strong></div>
          <a class="dropdown-item" v-if="$route.name!==''" @click="$router.push('profile')"><i class="fa fa-user"></i> {{web_texts.header.profile}}</a>
          <!--<a class="dropdown-item" @click="$router.push('settings')"><i class="fa fa-wrench"></i> Configuració</a>-->
          <a class="dropdown-item" @click="logout"><i class="fa fa-lock"></i> {{web_texts.header.logout}}</a>
        </div>
      </dropdown>
      <li class="nav-item hidden-md-down">
        <!-- Thin li is to do air -->
      </li>
    </ul>

  </navbar>
</template>
<script>
  import trans_cat from '../translates/cat/Components';
  import trans_es from '../translates/es/Components';
  import middleware from "../utilities/middlewares";
  import constants from '../constants'
  import navbar from './Navbar'
  import {dropdown} from 'vue-strap'

  export default {
    name: 'app-header',
    data() {
      return {
        web_texts: { "aside": {}, "breadcrumb": {}, "footer": {}, "header": { "select_system": "Seleccionar Sistema ", "profile": "Perfil", "logout": "Sortir" }, "navbar": { "general_info": "Informació general", "start": "Inici", "devices": "Dispositius", "shunttings": "Maniobres", "status_system": "Estat sistema", "notifications": "Notificacions", "messages": "Missatges", "events": "Esdeveniments", "informs": "Informes i Històrics", "maximeters": "Maxímetre", "export_inform": "Exportar Informació", "inf_energetic": "Inf. Energétic", "inf_costs": "Inf. Costos", "invoice_simulation": "Simulació Factura", "annually_inform": "Inf. Anual", "app_info": "Informació APP", "sce_info": "Informació SCE" }, "sidebar": {} },
        user: '',
        system: ''
      }
    },
    components: {
      navbar,
      dropdown
    },
    props: {
      list: {
        type: Array,
        required: true,
        default: () => []
      },
      separator: String
    },
    created(){
        this.web_texts=middleware.selectTranslation(trans_cat,trans_es);
    },
    mounted(){
      var out=this;
      setTimeout(function () {
        out.showUser();
      },350);

    },
    watch: {
      '$route'(to, from) {
        this.showUser();
        this.web_texts=middleware.selectTranslation(trans_cat,trans_es);
      }
    },
    methods: {
      changeLang(lang){
        switch (lang) {
          case 'cat':
              console.log("Lang CAT")
              window.localStorage.setItem('lang','cat');
              window.location.reload()
            break;
          case 'es':
              console.log("Lang ES")
              window.localStorage.setItem('lang','es');
              window.location.reload()
            break;
          // case 'en':
          //
          //   break;
          default:
            //CAT
            return trans_cat;
        }
      },
      click() {
        // do nothing
      },
      sidebarToggle(e) {
        e.preventDefault();
        document.body.classList.toggle('sidebar-hidden');
      },
      mobileSidebarToggle(e) {
        e.preventDefault();
        document.body.classList.toggle('sidebar-mobile-show');
      },
      asideToggle(e) {
        e.preventDefault();
        document.body.classList.toggle('aside-menu-hidden');
      },
      logout(){
        window.localStorage.removeItem(constants.STORAGE_TOKEN_KEY);
        window.localStorage.removeItem('system');
        window.localStorage.removeItem('user');
        this.$router.push({path: 'login'});
      },
      isLast (index) {
        return index === this.list.length - 1
      },
      showName (item) {
        return item.meta && item.meta.label || item.name
      },
      showUser(){
        var local_user=JSON.parse(window.localStorage.getItem('user'));
        if(local_user!==null){
          this.user=local_user;
        }else {
          this.user={name: "S/D"}
        }

        var local_system=JSON.parse(window.localStorage.getItem('system'));
        if(local_system!==null){
          this.system=local_system;
        }else {
          this.system={name: " "}
        }
      }
    }
  }
</script>

<style lang="css">
  .margin-left-15 {
    margin-left: 15px;
  }
  .dropdown-toggle::after {
    /*display: none !important;*/
  }
</style>



// WEBPACK FOOTER //
// Header.vue?a012c7b6